import { render, staticRenderFns } from "./PostPicture.vue?vue&type=template&id=696a524e&scoped=true&"
import script from "./PostPicture.vue?vue&type=script&lang=js&"
export * from "./PostPicture.vue?vue&type=script&lang=js&"
import style0 from "./PostPicture.vue?vue&type=style&index=0&id=696a524e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696a524e",
  null
  
)

component.options.__file = "PostPicture.vue"
export default component.exports